import React from 'react';
import {Button} from '@taopix/taopix-design-system';
import AssetServiceAlbumThumbnail from '../AssetServiceAlbumThumbnail';
import {ExternalAssetAlbum} from '../RemoteAssetService';
import {useTranslation} from 'react-i18next';

export type FolderViewProps = {
  loading: boolean;
  albums: ExternalAssetAlbum[];
  nextPageToken: string;
  onNextPage: () => void;
  onClick: (album: ExternalAssetAlbum) => void;
};

const FolderView = ({albums, nextPageToken, onNextPage, onClick, loading}: FolderViewProps) => {
  const {t} = useTranslation();

  return (
    <div className={'overflow-auto'}>
      <ul className={'flex flex-wrap space-x-md'}>
        {albums.map((album: ExternalAssetAlbum, index: number) => {
          return (
            <AssetServiceAlbumThumbnail
              albumId={album.id}
              imgSource={album.imgSrc}
              albumName={album.name}
              onSelect={() => {
                onClick(album);
              }}
              key={`${album.id}-${index}`}
            />
          );
        })}
      </ul>
      {nextPageToken !== '' ? (
        <Button label={t('*:str_ButtonNextPage')} onClick={() => onNextPage()} loading={loading} />
      ) : (
        <></>
      )}
    </div>
  );
};

export default FolderView;
